import axios from 'axios'

const BASE_URL = process.env.REACT_APP_NEXTERA_API

export type ScheduleActivityDates = Record<string, string | null>

export interface ProjectScheduleActivity {
  id: number
  project_job_type_id: number
  floor_code: string
  tracker_name: string | null
  job_type_name: string | null
  external_task_id: string
  external_guid: string | null
  task_code: string
  task_name: string
  task_type: string
  status_code: string
  wbs_path: string | null
  dates: ScheduleActivityDates | null
  source_file_name: string | null
  created_by_user_id: number
  last_modified_by_user_id: number
  registered_on: string
  last_modified_on: string
}

export interface ScheduleActivityWriteItem {
  external_task_id: string
  external_guid?: string | null
  task_code: string
  task_name: string
  task_type?: string
  status_code?: string
  wbs_path?: string | null
  floor_code: string
  project_job_type_id: number
  dates?: ScheduleActivityDates | null
}

export interface ScheduleActivityReplacePayload {
  source_file_name?: string | null
  activities: ScheduleActivityWriteItem[]
}

export const listProjectScheduleActivities = async (
  projectId: string,
): Promise<{ data: ProjectScheduleActivity[] }> => {
  const res = await axios.get(
    `${BASE_URL}/project/${projectId}/schedule-activities`,
  )
  const body = res.data
  if (Array.isArray(body)) {
    return { data: body }
  }
  if (body && Array.isArray(body.data)) {
    return { data: body.data }
  }
  return { data: [] }
}

export const replaceProjectScheduleActivities = async (
  projectId: string,
  payload: ScheduleActivityReplacePayload,
): Promise<{ data: ProjectScheduleActivity[] }> => {
  const res = await axios.put(
    `${BASE_URL}/project/${projectId}/schedule-activities/replace`,
    payload,
  )
  const body = res.data
  if (Array.isArray(body)) {
    return { data: body }
  }
  if (body && Array.isArray(body.data)) {
    return { data: body.data }
  }
  return { data: [] }
}
